/* eslint-disable */
import React, { Component } from 'react';
import * as wording from '../js/wording.js';

import * as api from '../js/api.js';
import './display.scss'
class CurrentRaceInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			eMsg: {},
			CURRENT_EVENT: "",
			CALLING_EVENT: "",
			FINAL_CALL: "",
			MSG: "",
			LAST_UPDATE_FINAL: "",
			LAST_UPDATE_CALLING: "",
			LAST_UPDATE_CURRENT: "",
			LAST_UPDATE_MSG: "",

		};
		this.getInfo = this.getInfo.bind(this);
	}

	componentDidMount() {
		wording.getWording('/wording/info.json').then((wordingJson) => this.setState({ eMsg: wordingJson, ready: true }));
		document.title="HKISA 比賽進度系統";
		this.getInfo(function (data, _this) {
			if (data != null || data.length > 0) {
				_this.setState({
					CURRENT_EVENT: data.result.CURRENT_EVENT,
					CALLING_EVENT: data.result.CALLING_EVENT,
					FINAL_CALL: data.result.FINAL_CALL,
					MSG: data.result.MSG,
					LAST_UPDATE_FINAL: data.result.LAST_UPDATE_FINAL,
					LAST_UPDATE_CALLING: data.result.LAST_UPDATE_CALLING,
					LAST_UPDATE_CURRENT: data.result.LAST_UPDATE_CURRENT,
					LAST_UPDATE_MSG: data.result.LAST_UPDATE_MSG,
					EVENT_NAME: data.result.EVENT_NAME
				})
			}
		})

		setInterval(() => {
			this.getInfo(function (data, _this) {
				if (data != null || data.length > 0) {
					_this.setState({
						CURRENT_EVENT: data.result.CURRENT_EVENT,
						CALLING_EVENT: data.result.CALLING_EVENT,
						FINAL_CALL: data.result.FINAL_CALL,
						MSG: data.result.MSG,
						LAST_UPDATE_FINAL: data.result.LAST_UPDATE_FINAL,
						LAST_UPDATE_CALLING: data.result.LAST_UPDATE_CALLING,
						LAST_UPDATE_CURRENT: data.result.LAST_UPDATE_CURRENT,
						LAST_UPDATE_MSG: data.result.LAST_UPDATE_MSG,
						EVENT_NAME: data.result.EVENT_NAME
					})
				}
			})

		}, 5000)
	}

	componentWillUnmount() {
	}

	getInfo(callback) {
		var apiInfo = {
			api: window.info.config.filepathname + '/php/api/getDisplayInfo.php',
		};
		api.post(this, apiInfo, function (data, _this) {
			var returnJson = data || null;
			callback(returnJson, _this);
			return;
		});
	}

	render() {

		return (
			<div id="display">
				<div class="responsive-container">
					<div class="responsive-layout">
						<div class='item item-0'>
							<div dangerouslySetInnerHTML={{__html:this.state.EVENT_NAME}}></div>
						</div>
						<div class="item item-1">
							<div class='inner-item'>
								<div class='item-1-1'>
									<div class="header">
										{this.state.eMsg.calling}
										<br/>
										<span class='eng'>{this.state.eMsg.callingen}</span>
										<div class="time">
										<table>
											<tr>
												<td>{this.state.eMsg.lastUpdate}</td>
												<td rowSpan={2}><div dangerouslySetInnerHTML={{__html:this.state.LAST_UPDATE_CALLING}}></div></td>
											</tr>
											<tr>
												<td class='eng'>{this.state.eMsg.lastUpdateen}</td>
											</tr>
										</table>
										</div>
									</div>
									<div class=" calling">
										{this.state.CALLING_EVENT}
									</div>
								</div>
								<div class='item-1-2'>
									<div class="finalTitle">
										{this.state.eMsg.final}<br/>
										<span class='eng'>{this.state.eMsg.finalen}</span>
										<div class="time">
										<table>
											<tr>
												<td>{this.state.eMsg.lastUpdate}</td>
												<td rowSpan={2}>{this.state.LAST_UPDATE_FINAL}</td>
											</tr>
											<tr>
												<td class='eng'>{this.state.eMsg.lastUpdateen}</td>
											</tr>
										</table>
										</div>
									</div>
									<div class=" final">
										<div dangerouslySetInnerHTML={{__html:this.state.FINAL_CALL}}></div>
									</div>
								</div>
							</div>
						</div>
						<div class="item item-2">
							<div class="item-2-1">
								<div class="header">
									{this.state.eMsg.current}<br/>
										<span class='eng'>{this.state.eMsg.currenten}</span>
									<div class="time">
										<table>
											<tr>
												<td>{this.state.eMsg.lastUpdate}</td>
												<td rowSpan={2}>{this.state.LAST_UPDATE_CURRENT}</td>
											</tr>
											<tr>
												<td class='eng'>{this.state.eMsg.lastUpdateen}</td>
											</tr>
										</table>
										
									</div>
								</div>
								<div class='inner-item2'>
									<div class=" current">
										<div dangerouslySetInnerHTML={{__html:this.state.CURRENT_EVENT}}></div>
									</div>
								</div>
							</div>
						</div>
						<div class="item item-3">
							<div class="">								
								<div dangerouslySetInnerHTML={{__html:this.state.MSG}}></div>
							</div>
						</div>
					</div>
				</div>
			</div >

		);
	}
}

export default CurrentRaceInfo;